<template>
  <div>
    <section class="g-filterSearch uc-ml10">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        class="item"
        :class="item.status == query.status ? 'on' : ''"
        @click="
          query.status = item.status;
          loadData();
        "
      >
        {{ item.name }}
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入您想搜索的培训班"
          class="uc-input"
          v-model="query.keyword"
          @keyup.enter="loadData"
        />
        <input
          type="submit"
          value="搜索"
          class="uc-btn blue"
          @click="loadData"
        />
      </div>
    </section>

    <section class="g-list uc-ml10">
      <div class="content-empty" v-if="list.total_count == 0">
        <div class="emptyimg-box"></div>
        <p>暂无相关内容</p>
      </div>
      <div v-for="(item, index) in list.items" :key="index" class="item">
        <router-link
          :to="{ name: 'TrainClassDetails', params: { id: item.id } }"
          class="con"
        >
          <div class="img-box">
            <el-image :src="item.cover">
              <div slot="error" class="image-slot">
                <img src="../../assets/images/default-hd.png" />
              </div>
            </el-image>
          </div>
          <div class="btm">
            <h3>{{ item.name }}</h3>
            <div class="txt">共{{ item.course_count }}课</div>
          </div>
        </router-link>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'StudyTrainClass',
  data() {
    return {
      tabList: [
        { name: '全部', status: -1 },
        { name: '未开始', status: 0 },
        { name: '进行中', status: 1 },
        { name: '已结束', status: 2 },
      ],
      query: {
        catalogId: undefined,
        status: -1,
        pageIndex: 1,
        pageSize: 9,
        keyword: undefined,
      },
      list: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getMyTrainClasses();
    },
    async getMyTrainClasses() {
      const response = await this.$api.train.getMyTrainClasses(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
  },
};
</script>
